// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bal_a","InstagramEmbed__mask":"bal_b bhe_bi bhe_bo bhe_vt"};